import * as React from 'react';
import { Site } from 'sections/client-management/entities';
import { IOffsiteCampaign } from 'sections/offsite-campaigns/entities/offsiteCampaign';
import { IValue as ImportedValue, OffsiteCampaignsListProvider } from './OffsiteCampaignsListProvider';
import { ActionTypes, OffsiteCampaignsListReducer } from './OffsiteCampaignsListReducer';

export type IValue = ImportedValue;

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export interface IConfiguredDispatcher {
  id: string;
  ownerId: string;
  dispatcher: string;
}

export type Dispatch = (action: IAction) => void;

export interface IState {
  campaigns: IOffsiteCampaign[];
  originalCampaigns: IOffsiteCampaign[];
  showCloneModal: boolean;
  campaign: IOffsiteCampaign;
  site?: Site;
}

export const defaultContextValues: IState = {
  campaigns: [],
  originalCampaigns: [],
  showCloneModal: false,
  campaign: undefined,
  site: {},
};

export const OffsiteCampaignsListStateContext = React.createContext<IState | undefined>(undefined);
export const OffsiteCampaignsListDispatchContext = React.createContext<Dispatch | undefined>(undefined);

function useOffsiteCampaignsListState() {
  const context = React.useContext(OffsiteCampaignsListStateContext);
  if (context === undefined) {
    throw new Error('useCampaignsListState must be used within a CampaignsListProvider');
  }
  return context;
}

function useOffsiteCampaignsListDispatch() {
  const context = React.useContext(OffsiteCampaignsListDispatchContext);
  if (context === undefined) {
    throw new Error('UseOffsiteCampaignsListDispatch must be used within a OffsiteCampaignsListProvider');
  }
  return context;
}

export {
  OffsiteCampaignsListProvider,
  OffsiteCampaignsListReducer,
  useOffsiteCampaignsListState,
  useOffsiteCampaignsListDispatch,
};
